// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2u2ed","loaderOuter":"PageOverlayLoader_loaderOuter__3Qn8F"};